import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';

import { BaseControlComponent } from '~components/form/base-control/base-control.component';
import { ErrorTooltipDirective } from '~core/directives/error-tooltip.directive';

@Component({
    selector: 'arc-datepicker',
    templateUrl: './datepicker.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        MatFormField,
        ErrorTooltipDirective,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        MatDatepickerInput,
        MatDatepickerToggle,
        MatSuffix,
        MatDatepicker,
        TranslocoPipe
    ]
})
export class DatepickerComponent extends BaseControlComponent implements OnInit {
    @Input() min?: Date;
    @Input() max?: Date;
    @Input() showHint = true;

    dateFormat = '';

    override ngOnInit(): void {
        super.ngOnInit();
        this.dateFormat = this._translationService.current.dateFormat;
    }
}
